import { useState } from "react";
import { Pencil } from "lucide-react";

const EditIconFileUpload = () => {
  // Default image URL
  const defaultImage = "https://via.placeholder.com/300";

  // State to manage the preview image
  const [preview, setPreview] = useState(defaultImage);

  // Function to handle file upload
  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];

    if (uploadedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result); // Set the uploaded image as the preview
      };
      reader.readAsDataURL(uploadedFile); // Read the file as a data URL
    } else {
      setPreview(defaultImage); // Fallback to the default image if no file is selected
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="relative w-64 h-64 border rounded-lg shadow-lg overflow-hidden">
        {/* Display the default or uploaded image */}
        <img
          src={preview}
          alt="Uploaded Preview"
          className="w-full h-full object-cover"
        />

        {/* Edit icon button to trigger file upload */}
        <label className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white p-2 rounded-full shadow-md cursor-pointer hover:bg-gray-100">
          <Pencil size={20} className="text-gray-700" />
          <input
            type="file"
            className="hidden"
            onChange={handleFileChange}
            accept="image/*"
          />
        </label>
      </div>

      {/* Instructions */}
      <p className="mt-4 text-gray-600">
        Click the edit icon to upload a new image.
      </p>
    </div>
  );
};

export default EditIconFileUpload;